/* eslint-disable @typescript-eslint/naming-convention */
// import { FuncOrGroup } from '@react-awesome-query-builder/antd';

// const DATE_BETWEEN: FuncOrGroup = {
//   label: 'DATE BETWEEN',
//   sqlFunc: 'DATE_BETWEEN',
//   returnType: 'boolean',
//   jsonLogic: "DATE_BETWEEN",
//   args: {
//     date: {
//       label: 'Date',
//       type: 'date',
//     //   valueSources: ['value', 'field', 'func'],
//       valueSources: ['value', 'field'],
//     },
//     start: {
//       label: 'Start Day',
//       type: 'date',
//       valueSources: ['value', 'field'],
//     },
//     end: {
//       label: 'End Day',
//       type: 'date',
//       valueSources: ['value', 'field'],
//     },
//   },
//   allowSelfNesting: false,
  
// };

// export default DATE_BETWEEN;

// operators/dateBetween.ts

/* DATE_BETWEEN.ts */
import type { Func } from "@react-awesome-query-builder/core";

const DATE_BETWEEN: Func = {
  label: "DATE BETWEEN",
  returnType: "boolean",
  jsonLogic: "DATE_BETWEEN", // This maps to your registered jsonLogic function
  sqlFunc: "DATE_BETWEEN",   // Optional: for SQL export
  args: {
    date: {
      label: "Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
    start: {
      label: "Start Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
    end: {
      label: "End Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
  },
  formatFunc: (formattedArgs) =>
    `DATE_BETWEEN(${formattedArgs.date},${formattedArgs.start},${formattedArgs.end})`,
  sqlFormatFunc: (formattedArgs) =>
    `DATE_BETWEEN(${formattedArgs.date},${formattedArgs.start},${formattedArgs.end})`,
};

export default DATE_BETWEEN;




